/**
 * Main config file for Online Prints Editor
 *
 * The values (#{foo}) that should be different for different environments
 * (dev, prod, test), are handled by Octopus when deploying. These
 * values are also handled by gulp, when building for dev.
 * @type {Object}
 */
export default {
    EditorId: '018b6ef3-c90d-4274-abc4-5f2afe6e9ba1',
    UploadRegistrationApi: '#{UploadRegistrationApi}',
    ProductApi: '#{ProductApi}',
    CurrencyApi: '#{CurrencyApi}',
    EditorGatewayApi: '#{EditorGatewayApi}',
    PhotoOrganiseAuthApi: '#{PhotoOrganiseAuthApi}',
    PhotoOrganiseQueryApi: '#{PhotoOrganiseQueryApi}',
    TemporarySelectionApi: '#{TemporarySelectionApi}',
    newRelicEnabled: '#{newRelicEnabled}',
    newRelicLicenseKey: '#{newRelicLicenseKey}',
    newRelicApplicationID: '#{newRelicApplicationID}',
    oauthClientId: '#{oauthClientId}',
    oauthRedirectUrl: '#{oauthRedirectUrl}',
    oauthAuthorizationUrl: '#{oauthAuthorizationUrl}',
    photoUpload: {
        remap: '#{photoUpload.remap}',
        regex: '#{photoUpload.remapRegex}'
    },
    EditorModes: {
        standard: ['PAP_910', 'PAP_911', 'PAP_913', 'PAP_914', 'PAP_915'],
        polaroid: ['PAP_912']
    },
    PolaroidPrintWidth: 'PAP_910-4.8032',
    EditServerUrl: '#{EditServerUrl}',
    ShowLeavePageWarning: '#{ShowLeavePageWarning}',
    UploadSettings: {
        parallel: 6,
        maxFileSize: '25mb',
        mimeTypes: ['image/jpg', 'image/jpeg', 'image/png'],
        maxNumberOfFiles: 1500,
        maxPhotoPixels: 133930126,
        retry: { //For ajax requests
            times: 5, //How many times should the application try
            waitTimeBetweenRetries: 1000, //The ms waiting between retries
            network: { //For network specifc errors
                times: 500, //Maybe network connection is temporarly down (in ms)
                waitTimeBetweenRetries: 5000 //The ms between each try
            }
        }
    },
    PhotoorganisePerPage: 100,
    ProductCategories: [
        {
            label: null,
            getLabelFromProductId: 'PAP_910',
            products: ['PAP_910']
        },
        {
            label: null,
            getLabelFromProductId: 'PAP_911',
            products: ['PAP_911']
        },
        {
            label: 'Retro',
            products: ['PAP_910_polaroid']
        },
        {
            label: null,
            getLabelFromProductId: 'PAP_912',
            products: ['PAP_912']
        },
        {
            label: "Enlargements",
            products: ['PAP_913', 'PAP_915', 'PAP_914']
        }
    ],
    LayoutBreakpoints: {
        small: 640
    },
    UpsellProducts: [
        {from: 'PAP_910', to: 'PAP_911'}
    ],
    NumberOfRetriesOnFail: 10,
    DelayTimeoutDuration: 1000,
    BulkSizeOfUploadImages: 6,
    // maximum time allowed for the upload of a single photo (otherwise defaults to 2 minutes in Chrome)
    // 60000 defines a single minute
    SinglePhotoUploadTimeout: 15 * 60000,
    ProductRatioWarning: 0.025,
    LowResolutionWarningThreshold: 300,
    LowResolutionStopThreshold: 150,
    GalleryImagesPerPage: 24,
    ProductItemsPerPage: 50,
    MemoryManagement: {
        removeOutOfSightImagesAfterSec: 60 //After this amount of seconds, remove images that are not visible on the page from memory
    },
    VendorDefaults: {
        paperType: "GLOSSY"
    },
    VendorVariables: {
        1200: {
            customerServiceUrl: "http://www.albelli.nl/help/overzicht",
            privacyUrl: "http://www.albelli.nl/privacy",
            disclaimerUrl: "http://www.albelli.nl/disclaimer",
            siteUrl: "http://www.albelli.nl",
            copyrightName: "Albelli",
            allowSelectFromPhotoorganise: false,
            logoClassName: "albelli"
        },
        1207: {
            customerServiceUrl: "http://www.albelli.be/help/overzicht",
            privacyUrl: "http://www.albelli.be/privacy",
            disclaimerUrl: "http://www.albelli.be/disclaimer",
            siteUrl: "http://www.albelli.be",
            copyrightName: "Albelli",
            allowSelectFromPhotoorganise: false,
            logoClassName: "albelli"
        },
        1201: {
            customerServiceUrl: "http://www.albelli.de/hilfe/zusammenfassung",
            privacyUrl: "http://www.albelli.de/datenschutz",
            disclaimerUrl: "http://www.albelli.de/agb",
            siteUrl: "http://www.albelli.de",
            copyrightName: "Albelli",
            allowSelectFromPhotoorganise: false,
            logoClassName: "albelli"
        },
        1203: {
            customerServiceUrl: "http://www.albelli.fr/aide/resume",
            privacyUrl: "http://www.albelli.fr/protection-de-la-vie-privee",
            disclaimerUrl: "http://www.albelli.fr/conditions-generales",
            siteUrl: "http://www.albelli.fr",
            copyrightName: "Albelli",
            allowSelectFromPhotoorganise: false,
            logoClassName: "albelli"
        },
        1205: {
            customerServiceUrl: "http://www.albelli.co.uk/help/overview",
            privacyUrl: "http://www.albelli.co.uk/privacy-statement",
            disclaimerUrl: "http://www.albelli.co.uk/disclaimer",
            siteUrl: "http://www.albelli.co.uk",
            copyrightName: "Albelli",
            allowSelectFromPhotoorganise: false,
            logoClassName: "albelli"
        },
        1221: {
            customerServiceUrl: "http://www.bonusprint.co.uk/customer-care",
            privacyUrl: "http://www.bonusprint.co.uk/about-us/privacy-policy",
            disclaimerUrl: "http://www.bonusprint.co.uk/about-us/terms",
            siteUrl: "http://www.bonusprint.co.uk",
            copyrightName: "Bonusprint",
            allowSelectFromPhotoorganise: false,
            logoClassName: "bonusprint"
        },
        1213: {
            customerServiceUrl: "http://www.onskefoto.se/hjalp/oversikt",
            privacyUrl: "http://www.onskefoto.se/sekretess",
            disclaimerUrl: "http://www.onskefoto.se/villkor",
            siteUrl: "http://www.onskefoto.se",
            copyrightName: "Önskefoto",
            allowSelectFromPhotoorganise: true,
            logoClassName: "onskefoto"
        },
        1215: {
            customerServiceUrl: "http://www.fotoknudsen.no/hjelp/oversikt",
            privacyUrl: "http://www.fotoknudsen.no/personvern",
            disclaimerUrl: "http://www.fotoknudsen.no/vilkar",
            siteUrl: "http://www.fotoknudsen.no",
            copyrightName: "FotoKnudsen",
            allowSelectFromPhotoorganise: true,
            logoClassName: "fotoknudsen"
        },
        1217: {
            customerServiceUrl: "https://www.monalbumphoto.fr/aide/resume",
            privacyUrl: "https://www.monalbumphoto.fr/declaration-de-confidentialite-client",
            disclaimerUrl: "https://www.monalbumphoto.fr/conditions-generales",
            siteUrl: "https://www.monalbumphoto.fr",
            copyrightName: "monalbumphoto",
            allowSelectFromPhotoorganise: true,
            logoClassName: "monalbumphoto"
        }
    },
    ManufacturingData: {
        products: {
            PAP_910: {
                borderWidth: 4,
                dpi: 300
            },
            PAP_910_polaroid: {
                borderWidth: 4,
                dpi: 300
            },
            PAP_911: {
                borderWidth: 6,
                dpi: 300
            },
            PAP_912: {
                borderWidth: 4,
                dpi: 300
            },
            PAP_913: {
                borderWidth: 6,
                dpi: 300
            },
            PAP_914: {
                borderWidth: 6,
                dpi: 300
            },
            PAP_915: {
                borderWidth: 6,
                dpi: 300
            }
        }
    },
    LogLevel: {
        /**
         *  Designates events that are very
         *  harmful and will eventually lead to application failure.
         */
        FATAL: 4,

        /**
         *  Designates error events that might
         *  still allow the application to continue running.
         */
        ERROR: 3,

        /**
         *  Designates events that could be
         *  harmful to the application operation.
         */
        WARN: 2,

        /**
         *  Designates informational messages that
         *  highlight the progress of the application at coarse-grained level.
         */
        INFO: 1,

        /**
         *  Designates informational level
         *  messages that are fine grained and most helpful when debugging an
         *  application.
         */
        DEBUG: 0
    },
    polaroidEnabled: true,
    photoSelector: {
        range: {max: 1400, min: 1},
        photoOrganiserQueryApiUrl: "#{PhotoOrganiseQueryApi}/api/v1", //Will be automatically set by deployment server for each environment
        startPage: "photoorganiser", //what page should the photoselector show on startup
        autoCloseOnSelection: false,        
        photoOrganiserAuthenticator: () => Promise.resolve(sessionStorage.getItem("photoOrganiseLoginToken")) //A function that returns a promise which gives a token. Returns empty string if no token available. Only needed if using photoorganiser as image source
    },
    photoOrganiserVendorNames: {
        1213: "minbildbank",
        1215: "minnebanken",
        1217: "Mesphotos"
    }
};
